import { db } from '../configs/firebaseConfig'
import { getDocs, getDoc, doc, collection, query, where, orderBy } from 'firebase/firestore'

export const getCollection = async (collectionName: string) => {
  try {
    const collectionRef = collection(db, collectionName);
    const querySnapshot = await getDocs(collectionRef);

    const documents = querySnapshot.docs.map(doc => ({
      id: doc.id, ...doc.data(),
    }));

    return documents;
  } catch (error) {
    console.error("Error fetching collection:", error);
    return [];
  }
};

export const getCollectionById = async (collectionName: string, docId: string) => {
  const docRef = doc(db, collectionName, docId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return {id: docSnap.id, ...docSnap.data()}
  } else {
    console.log("No such document!");
    return null;
  }
};

export const getCollectionByRestaurant = async (collectionName: string, paramId: string) => {
  const collectionRef = collection(db, collectionName)
  const baseQuery = query(collectionRef, where('restaurantId', '==', paramId), orderBy('createdAt', 'desc'))
  
  try {
    const querySnapshot = await getDocs(baseQuery)

    if (!querySnapshot.empty) {
      const docs = querySnapshot.docs.map((doc) => {
        const data = doc.data()
        return { ...data, id: doc.id }
      })
      return docs
    } else {
      return null
    }
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw new Error("Failed to fetch data");
    return null
  }
};